import { ApsAssignedActionTypes, FetchApsAssigned, LoadApsAssigned } from './aps_assinged.actions';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { Injectable } from '@angular/core';
import { Effect } from '@ngrx/effects';
import { DataPersistence } from '@nrwl/nx';
import { map } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { ApiService } from 'src/app/services/api.service';
import { RxdbService } from 'src/app/services/rxdb.service';
import { AppState } from '..';
import { ApsAssignedList } from 'src/app/models/aps-assigned-list';

@Injectable({providedIn: 'root'})
export class ApsAssignedEffects {
  @Effect()
  LoadApsAssigned$ = this.apsAssingedPersistence.fetch(ApsAssignedActionTypes.FetchApsAssigned, {
      run: (action: FetchApsAssigned, state: Array<ApsAssignedList>) => {
        return this.api.getReportList()
        .pipe(map((res: Array<ApsAssignedList>) => {
          return new LoadApsAssigned(res);
        }));
      },
      onError: (action: FetchApsAssigned, error) => {
        console.error('Error', error);
        this.toastr.error(JSON.stringify(error.error.error_description), 'Error Message');
      }
  });

  constructor(
    private apsAssingedPersistence: DataPersistence<Array<ApsAssignedList>>,
    private toastr: ToastrService,
    private api: ApiService,
    private rxDb: RxdbService
) {}
}
